'use strict';

var DailyCtrl = function ($scope,
                          $state,
                          $stateParams,
                          shiftPlanning,
                          gettextCatalog,
                          office,
                          services,
                          Notification,
                          moment,
                          ResourceDA,
                          shiftClipboard,
                          ShiftPlanningDA,
                          ModalService,
                          DatepickerSettings) {

    var self = this;

    this.gettextCatalog = gettextCatalog;
    this._Notification = Notification;
    this._ResourceDA = ResourceDA;
    this._shiftClipboard = shiftClipboard;
    this._ShiftPlanningDA = ShiftPlanningDA;
    this._state = $state;
    this._stateParams = $stateParams;
    this._moment = moment;
    this._services = services;
    this._ModalService = ModalService;
    this.showAbsence = true;
    this.employee = shiftPlanning.employee;
    this.weekDays = [];
    this.office = office;
    this.dates = shiftPlanning.dates;
    this.currentMonth = moment(this._stateParams.date).toDate();
    this.dtpOptions = DatepickerSettings.minMonth;
    this.serviceName = '';

    this.absenceReasons = [
        {
            key: 'other',
            text: gettextCatalog.getString('Other')
        },
        {
            key: 'vacation',
            text: gettextCatalog.getString('Vacation')
        },
        {
            key: 'ill',
            text: gettextCatalog.getString('Ill')
        },
        {
            key: 'pd',
            text: gettextCatalog.getString('PD')
        }
    ];

    $scope.$watch(function () {
        return self.currentMonth;
    }, function (newMonth, oldMonth) {
        if (newMonth && newMonth.toString() !== oldMonth.toString()) {
            var newDate = moment(newMonth).startOf('month').format('YYYY-MM-DD');

            self._state.go('private.main.shiftPlanning.daily', {
                employeeId: self.employee._id,
                date: newDate
            }, {notify: false});
        }
    });

    $scope.$on('t2g:shift-planning:save:clicked', () => {
      this.saveDaily();
    });

    if (this._stateParams.serviceId) {
        this.showAbsence = false;
        this.serviceName = services[this._stateParams.serviceId].label;
    }
};

/**
 * month change handler
 * @param {String} month
 */
DailyCtrl.prototype.changeMonth = function (month) {
    var monthMoment = this._moment(this.currentMonth).startOf('month');
    monthMoment.add(month, 'month');
    this.currentMonth = monthMoment.toDate();
};


/**
 * save daily working hours
 */
DailyCtrl.prototype.saveDaily = function () {
    var self = this;
    var update = {
        resource: this.employee._id,
        month: this._moment(this.currentMonth).format('YYYY-MM-DD'),
        dates: {}
    };

    if (this._stateParams.serviceId) {
        const selectedService = this._services[this._stateParams.serviceId];
        update.serviceType = selectedService.type;
        update.serviceId = this._stateParams.serviceId;
    }

    _.forEach(this.dates, function (date) {
        var dateKey;

        if (date.type !== 'default') {
            dateKey = self._moment(date.date).format('YYYY-MM-DD');
            update.dates[dateKey] = date;
        }
    });


    this._ShiftPlanningDA
        .update(update)
        .then(
            function (response) {
                if (response.openAppointments > 0) {
                    self._ModalService.openShiftPlanningAbsenceModal(
                        self.employee._id,
                        response.openAppointments,
                        response.absenceDates,
                        () => {
                    });
                }
                self._Notification.addSuccessMessage(self.gettextCatalog.getString('Working hours saved'));
            },
            function (error) {
                self._Notification.addErrorMessage(self.gettextCatalog.getString('Cant save working hours (Error: {{error}})', {error: error}));
            }
        );
};


/**
 * copy a shift
 * @param {Number} index
 */
DailyCtrl.prototype.copy = function (index) {
    this._shiftClipboard.copy(this.dates[index]);
};


/**
 * paste clipboard to a date
 * @param {Number} index
 */
DailyCtrl.prototype.paste = function (index) {
    this._shiftClipboard.paste(this.dates[index]);
};


/**
 * handler if type of daily planning changed
 * @param {Number} index
 */
DailyCtrl.prototype.typeChanged = function (index) {
    var date = this.dates[index];
    var type = date.type;

    switch (type) {
        case 'default':
            var dayOfWeek = this._moment(date.date).weekday();
            date.times = _.cloneDeep(this.employee.workingHours[dayOfWeek].times);
            date.available = true;

            delete date.absence;
            delete date.reason;
            break;
        case 'custom':
            date.available = true;
            delete date.absence;
            delete date.reason;
            break;
        case 'absence':
            date.available = false;
            date.absence = true;
            date.reason = 'other';
            break;

    }
};

DailyCtrl.prototype.addDailyTime = function (dayIndex, timeIndex, before) {
  const currentTime = this.dates[dayIndex].times[timeIndex];
  const insertIndex = before ? timeIndex : timeIndex + 1;
  let start = 0;
  let end = 1440;

  if (before) {
    end = Math.max(0, currentTime.start - 30);

    if (timeIndex > 0) {
      const beforeTime = this.dates[dayIndex].times[timeIndex - 1];
      start = Math.max(0, beforeTime.end);
    } else{
      start = Math.max(0, end - 60);
    }
  } else {
    start = currentTime.end + 30;
    end = Math.min(1440, start + 60);
  }

  this.dates[dayIndex].times.splice(insertIndex, 0, { start, end});
};


/**
 * remove daily secondary time
 * @param {Number} index
 */
DailyCtrl.prototype.removeDailyTime = function (dayIndex, timeIndex) {
    this.dates[dayIndex].times.splice(timeIndex, 1);
};

module.exports = DailyCtrl;
